<template>
  <div>
    <BaseTopLine>
      <div class="d-flex gap-10 align-items-center"></div>
    </BaseTopLine>

    <!-- новый -->
    <div
      class="tw-bg-main2 tw-py-[10px] tw-px-[20px] tw-rounded-[6px] tw-mx-[26px] tw-text-[12px]"
    >
      <div class="tw-flex tw-items-end tw-gap-[20px] tw-text-white">
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text9"] }}
          </label>
          <BaseInputNew
            @keyupEnter="getData"
            inputClass="tw-app-input-dark"
            @input="handleQuickGosNumberInput"
            inputName="vehicles__gosnumber"
            :value="quickFilterGosNumber"
          />
        </div>
        <div class="tw-app-input-container">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text4"] }}
          </label>
          <BaseInputNew
            @keyupEnter="getData"
            inputClass="tw-app-input-dark"
            @input="handleQuickRinInput"
            inputName="vehicles__gosnumber"
            :value="quickFilterRin"
          />
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text8"] }}
          </label>
          <BaseSelect
            v-model="selectsFilter.markModel"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterMarkModelOptions"
            track-by="vehicles__name"
            label="label"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text7"] }}
          </label>
          <BaseSelect
            v-model="selectsFilter.type"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterTypeOptions"
            track-by="vehicle_types__code"
            label="label"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text6"] }}
          </label>
          <BaseSelect
            v-model="selectsFilter.place"
            track-by="vehicle_places__id"
            label="label"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterPlacesOptions"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>
        <div class="tw-app-input-container multiselect-type-1">
          <label class="tw-app-input-container-label">
            {{ dataLang["fine_subs_managment_text5"] }}
          </label>
          <BaseSelect
            v-model="selectsFilter.city"
            track-by="cities__id"
            label="label"
            style="width: 100%"
            placeholder=""
            selectLabel=""
            deselectLabel=""
            :options="quickFilterCitiesOptions"
          >
            <template slot="noOptions">{{ dataLang["select_empty"] }}</template>
            <template slot="noResult">{{
              dataLang["select_search_empty"]
            }}</template>
            <template slot="selectedLabel">{{
              dataLang["select_selected"]
            }}</template>
            <template slot="deselectLabel">{{
              dataLang["select_unselect"]
            }}</template>
          </BaseSelect>
        </div>

        <div class="tw-flex tw-flex-row">
          <button type="button" class="tw-app-btn-primary" @click="getData">
            Найти
          </button>
          <button type="button" class="tw-app-btn-light" @click="resetFilter">
            Сбросить
          </button>
        </div>
      </div>
    </div>
    <!-- новый -->

    <div class="position-relative tw-px-[26px] tw-mt-[15px]">
      <!-- новая -->
      <div class="border border-system-secondary tariffs-container">
        <p class="tw-text-[15px] tw-font-semibold tw-text-forTitle tw-mb-[8px]">
          {{ dataLang["fine_subs_managment_text1"] }}
        </p>
        <div class="tariffs">
          <div class="tariffs__left">
            <div class="tariffs__left-title">Объектов</div>
            Тариф за 1 объект<br />
            в неделю
          </div>
          <div
            v-for="tarif in tariffs"
            :key="tarif.index"
            class="tariffs__item border border-system-secondary"
            :class="{ tariffs__active: shouldShowGreen(tarif) }"
          >
            <div v-if="shouldShowGreen(tarif)" class="tariffs__badge-container">
              <div class="tariffs__badge">Активный тариф</div>
            </div>
            <div class="tariffs__range">
              {{ tarif.range }}
            </div>
            <div class="tariffs__price">{{ tarif.tariff }} ₽</div>
          </div>
        </div>
      </div>
      <!-- новая -->
      <p
        class="tw-my-[15px] tw-text-[12px] tw-text-forText"
        v-html="
          $options.filters.translate('alert_text_72', {
            countObjectsWithFinesSubscription:
              countObjectsWithFinesSubscription,
            countObjects: objects.length,
            tariff: tarifAmount,
            totalAmount: countObjectsWithFinesSubscription * tarifAmount,
          })
        "
      ></p>

      <div>
        <ve-table
          class="fixed-header rest-style-table"
          v-if="objects.length"
          style="width: 100%; font-size: 11px; line-height: 13px"
          :table-data="objects"
          :columns="columns"
          :border-x="true"
          :border-y="true"
          :cellSelectionOption="{ enable: false }"
          :checkbox-option="{
            selectedRowKeys: selectedRowKeys,
            selectedRowChange: selectedRowChange,
            selectedAllChange: selectedAllChange,
            hideSelectAll: false,
          }"
          :row-style-option="{
            clickHighlight: false,
            stripe: true,
          }"
          row-key-field-name="vehicles__id"
          ref="mainTable"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tariffs-container {
  padding: 8px 15px;
  border-radius: 15px;
}
.tariffs {
  display: flex;
  justify-content: flex-start;
  gap: 5px;
  &__active {
    background-color: hsla(107, 69%, 97%, 1);
    border-color: #23b14d !important;
    .tariffs__price {
      color: #23b14d;
    }
    .tariffs__badge-container {
      position: absolute;
      top: 0;
      width: 100%;
      padding: 0 4px;
    }
    .tariffs__badge {
      font-size: 8px;
      text-align: center;
      background: #23b14d;
      color: #fff;
      padding: 3px 10px;
      border-radius: 1px 1px 8px 8px;
    }
  }
  &__left {
    font-size: 10px;
    display: flex;
    justify-content: end;
    flex-direction: column;
    align-items: end;
    padding: 6px;
    padding-bottom: 15px;
    text-align: right;
    max-width: 100px;
  }
  &__left-title {
    margin-bottom: 10px;
  }
  &__item {
    position: relative;
    padding: 10px 0;
    max-width: 95px;
    border-radius: 8px;
    flex-basis: 100%;
  }
  &__range {
    text-align: center;
    font-size: 11px;
    margin-top: 17px;
    margin-bottom: 8px;
  }
  &__price {
    color: #0056af;
    font-size: 16px;
    padding: 5px;
    text-align: center;
  }
}
/* Чекбокс в шапке таблицы */
:deep(.ve-table-header .ve-checkbox) {
  display: inline-block;
}

:deep(.ve-table-header .ve-checkbox .ve-checkbox-inner) {
  // background-color: #1d1e2c !important;
  border-color: #ffffff !important;
}

:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-input:checked
      + .ve-checkbox-inner
  ) {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-input:checked
      + .ve-checkbox-inner::after
  ) {
  border-color: #ffffff !important;
}

/* Промежуточное состояние — как неотмеченное */
:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-content.ve-checkbox-indeterminate
      .ve-checkbox-inner
  ) {
  // background-color: #1d1e2c !important;
  border-color: #ffffff !important;
}

:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-content.ve-checkbox-indeterminate
      .ve-checkbox-inner::after
  ) {
  display: none !important;
}

:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-input:indeterminate
      + .ve-checkbox-inner
  ) {
  background-color: #1d1e2c !important;
  border-color: #ffffff !important;
}

:deep(
    .ve-table-header
      .ve-checkbox
      .ve-checkbox-input:indeterminate
      + .ve-checkbox-inner::after
  ) {
  display: none !important;
}

/* Чекбоксы в теле таблицы */
:deep(.ve-table-body .ve-checkbox) {
  display: inline-block;
}

:deep(.ve-table-body .ve-checkbox .ve-checkbox-inner) {
  background-color: transparent !important;
  border-color: #cccccc !important;
}

:deep(
    .ve-table-body .ve-checkbox .ve-checkbox-input:checked + .ve-checkbox-inner
  ) {
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}

:deep(
    .ve-table-body
      .ve-checkbox
      .ve-checkbox-input:checked
      + .ve-checkbox-inner::after
  ) {
  border-color: #ffffff !important;
}

.green {
  background-color: #bcf098;
}
.tarif-info {
  background-color: #e3f0ff;
  p {
    border: 1px solid black;
    margin: 0;
    padding: 3px 0 3px;
  }
}
.tarif-info_tarif {
  width: 90px;
}
.my-8 {
  margin-top: 8px;
  margin-bottom: 8px;
}
.line-hover {
  background-color: #e3f0ff;
  transition: 0.3s ease;
  white-space: nowrap;
  color: black;
  &:hover {
    background-color: #005bff;
    color: white;
  }
}

.transport-quick-filter-bar {
  background: #1d1e2c;
  padding: 14px 0 16px;
  border-top: 1px solid #fff;
}

.transport-quick-filter-bar__inner {
  gap: 12px 0;
  row-gap: 12px;
  column-gap: 0;
}

.transport-quick-filter-bar__group {
  flex: 0 0 auto;
  min-width: 88px;
  max-width: 100%;
  padding-right: 14px;
  padding-left: 14px;
}

.transport-quick-filter-bar__group--grow {
  flex: 1 1 140px;
  min-width: 120px;
}

.transport-quick-filter-bar__label {
  display: block;
  color: #fff;
  font-size: 12px;
  line-height: 1.2;
  margin-bottom: 6px;
}

.transport-quick-filter-bar__vrule {
  align-self: stretch;
  width: 1px;
  min-height: 48px;
  background: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
}

.transport-quick-filter-bar__actions {
  padding-left: 18px;
  min-width: 120px;
}

.transport-quick-filter-bar__btn-find {
  border: none;
  border-radius: 6px;
  background: #f5e000;
  color: #1a1b23;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  cursor: pointer;
  line-height: 1;
  height: 24px;
  min-height: 24px;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.transport-quick-filter-bar__btn-find:hover {
  filter: brightness(1.05);
}

.transport-quick-filter-bar__btn-reset {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;
  padding: 4px 0 0;
  text-align: center;
}

.transport-quick-filter-bar__btn-reset:hover {
  color: #e0e0e0;
}

.transport-quick-filter-bar .base-input--new {
  padding: 2px 2px;
  font-size: 14px;
  border: 1px solid rgba(245, 245, 245, 1);
  background: rgba(245, 245, 245, 0.15);
  color: white;
  border-radius: 3px;
  height: 24px;
  box-sizing: border-box;
}

.transport-quick-filter-bar .base-input--new:focus {
  background: rgba(245, 245, 245, 0.15);
  border-color: rgba(245, 245, 245, 1);
  color: white;
  box-shadow: none;
}

.transport-quick-filter-bar .multiselect__tags {
  height: 24px;
  min-height: 24px;
  padding-left: 2px;
  border: 1px solid rgba(245, 245, 245, 1);
  background: rgba(245, 245, 245, 0.15);
  color: white;
  border-radius: 3px;
  box-sizing: border-box;
}

.transport-quick-filter-bar .multiselect {
  height: 24px;
  min-height: 24px;
}

.transport-quick-filter-bar .multiselect__select {
  width: 24px;
  height: 24px;
}

.transport-quick-filter-bar .multiselect__input,
.transport-quick-filter-bar .multiselect__single {
  min-height: 18px;
  line-height: 18px;
  font-size: 9px;
  background: transparent;
  color: white;
  position: absolute;
  overflow-x: hidden;
  width: 95%;
}

.transport-quick-filter-bar .multiselect__select:before {
  top: 7px;
  right: 5px;
  color: white;
  background-size: 10px 10px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-chevron-down" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"></path></svg>');
}

.transport-quick-filter-bar .multiselect__placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.button-activate {
  height: 36px;
  border-top: 1px solid #ededed;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  padding-inline: 10px;
  box-shadow: 0 7px 2px 0 #00000000;
  font-size: 14px;
  line-height: 19.6px;
  color: #1d1e2c;
  border-radius: 5px;
  cursor: pointer;
}

.button-activate--simple {
  background-color: #ddffe7;
}

.button-activate--block {
  background-color: #ffc8c8;
}

/* Health tooltip styles */
.health-tooltip {
  position: absolute;
  z-index: 5000;
  /* ensure above any modal overlays */
  max-width: 680px;
  color: #fff;
  background: #546887;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);

  /* arrow */
  &::after {
    content: "";
    position: absolute;
    left: var(--arrow-left, 50%);
    bottom: -12px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 12px solid #546887;
    /* point to item below */
  }
}

.health-tooltip__content {
  white-space: pre-wrap;
  font-size: 14px;
  line-height: 1.4;
}
</style>

<script>
import { VeTable } from "vue-easytable";
import { mapActions, mapState } from "vuex";
import GeneralService from "@/api/GeneralService";

export default {
  components: {
    VeTable,
  },
  data() {
    return {
      tariffs: [],
      objects: [],
      selectedRowKeys: [],
      selectsFilter: {
        city: {},
        place: {},
        markModel: {},
        type: {},
      },
      filter: {},
      quickFilterRin: "",
      quickFilterGosNumber: "",
    };
  },
  methods: {
    switchObjects(isSelected, objectIds) {
      const uri = isSelected
        ? "objects/command/enablefines"
        : "objects/command/disablefines";
      GeneralService.edit(uri, { objectIds })
        .then((res) => {
          GeneralService.get("/objects/table/finesmanagment")
            .then((res) => {
              this.objects = res.data.data.rows.map((item) => ({
                ...item,
                vehicles__is_active_fines: item.vehicles__is_active_fines === 1,
              }));
              this.selectedRowKeys = this.objects
                .filter((item) => item.vehicles__is_active_fines === true)
                .map((item) => item.vehicles__id);
              this.filter = res.data.data.filter;
            })
            .catch((err) => {
              this.$toast.error("Ошибка загрузки данных", { duration: 5000 });
            });
          this.$toast.success(res.data.message);
        })
        .catch(() => {
          this.$toast.error("Ошибка изменения статуса", { duration: 5000 });
        });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      const index = this.objects.findIndex(
        (item) => item.vehicles__id === row.vehicles__id
      );
      if (index !== -1) {
        this.objects[index].vehicles__is_active_fines = isSelected;
      }
      this.selectedRowKeys = selectedRowKeys;
      this.switchObjects(isSelected, [row.vehicles__id]);
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      const allIds = this.objects.map((item) => item.vehicles__id);
      this.objects.forEach((item) => {
        item.vehicles__is_active_fines = isSelected;
      });
      this.selectedRowKeys = selectedRowKeys;
      this.switchObjects(isSelected, allIds);
    },
    shouldShowGreen(tarif) {
      let nObjs = this.countObjectsWithFinesSubscription; // используем количество активных
      if (!nObjs) return false;
      let trimmed = tarif.range.trim();
      if (trimmed.includes("-")) {
        const parts = trimmed.split("-").map((part) => parseFloat(part.trim()));
        if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
          const [min, max] = parts;
          return nObjs >= min && nObjs <= max;
        }
      }
      if (trimmed.startsWith(">")) {
        const num = parseFloat(trimmed.slice(1).trim());
        if (!isNaN(num)) {
          return nObjs > num;
        }
      }
      return false;
    },
    handleQuickRinInput(payload) {
      this.quickFilterRin = payload?.value ?? "";
    },
    handleQuickGosNumberInput(payload) {
      this.quickFilterGosNumber = payload?.value ?? "";
    },
    getData() {
      GeneralService.get(`/objects/table/finesmanagment${this.dataQuery}`)
        .then((res) => {
          this.objects = res.data.data.rows.map((item) => ({
            ...item,
            vehicles__is_active_fines: item.vehicles__is_active_fines === 1,
          }));
          this.selectedRowKeys = this.objects
            .filter((item) => item.vehicles__is_active_fines === true)
            .map((item) => item.vehicles__id);
          this.filter = res.data.data.filter;
        })
        .catch(() => {
          this.$toast.error("Ошибка загрузки данных", { duration: 5000 });
        });
    },
    resetFilter() {
      this.selectsFilter = {
        city: {},
        place: {},
        markModel: {},
        type: {},
      };
      this.quickFilterRin = "";
      this.quickFilterGosNumber = "";
      this.getData();
    },
  },
  computed: {
    ...mapState("transportVehiclesModule", [
      "transportVehiclesData",
      "transportVehiclesLoadStatus",
      "transportVehiclesSelects",
    ]),
    ...mapState("userSettingModule", ["userSetting"]),
    ...mapState("translationModule", ["dataLang"]),
    tarifAmount() {
      if (!this.countObjectsWithFinesSubscription) return 0;
      let amount = Object.values(this.tariffs).find((i) =>
        this.shouldShowGreen(i)
      )?.tariff;
      return amount ? parseFloat(amount) : 0;
    },
    dataQuery() {
      let arr = [];
      if (this.quickFilterRin.length)
        arr.push({ field: "vehicles__id", value: this.quickFilterRin });
      if (this.quickFilterGosNumber.length)
        arr.push({
          field: "vehicles__gosnumber",
          value: `;percent;${this.quickFilterGosNumber};percent;`,
          operator: "like",
        });
      if (
        this.selectsFilter.city?.cities__id &&
        this.selectsFilter.city?.cities__id !== "*"
      )
        arr.push({
          field: "cities__id",
          value: this.selectsFilter.city?.cities__id,
        });
      if (
        this.selectsFilter.place?.vehicle_places__id &&
        this.selectsFilter.place?.vehicle_places__id !== "*"
      )
        arr.push({
          field: "vehicles__place_id",
          value: this.selectsFilter.place?.vehicle_places__id,
        });
      if (
        this.selectsFilter.markModel?.vehicles__name &&
        this.selectsFilter.markModel?.vehicles__name !== "*"
      )
        arr.push({
          field: "vehicles__name",
          value: this.selectsFilter.markModel?.vehicles__name,
        });
      if (
        this.selectsFilter.type?.vehicle_types__code &&
        this.selectsFilter.type?.vehicle_types__code !== "*"
      )
        arr.push({
          field: "vehicles__type_id",
          value: this.selectsFilter.type?.vehicle_types__code,
        });
      return arr.length ? `?where=${JSON.stringify(arr)}` : "";
    },
    columns() {
      return [
        {
          field: "vehicles__is_active_fines",
          key: "vehicles__is_active_fines",
          type: "checkbox",
          title: "",
          align: "center",
          width: 30,
        },
        {
          field: "vehicles__gosnumber",
          key: "vehicles__gosnumber",
          title: this.dataLang["fine_subs_managment_text9"],
          align: "center",
          width: "15%",
        },
        {
          field: "vehicles__sts",
          key: "vehicles__sts",
          title: this.dataLang["reg_contract_pdf_40"],
          align: "center",
          width: 70,
        },
        {
          field: "vehicles__id",
          key: "vehicles__id",
          title: this.dataLang["fine_subs_managment_text4"],
          align: "center",
          width: 70,
        },
        {
          field: "vehicles__name",
          key: "vehicles__name",
          title: this.dataLang["fine_subs_managment_text8"],
          align: "center",
          width: "20%",
          ellipsis: { showTitle: true, lineClamp: 1 },
        },
        {
          field: "vehicle_types__code",
          key: "vehicle_types__code",
          title: this.dataLang["fine_subs_managment_text7"],
          align: "center",
          width: "20%",
          ellipsis: { showTitle: true, lineClamp: 1 },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const code = row.vehicle_types__code;
            return <span>{this.dataLang[code] || code}</span>;
          },
        },
        {
          field: "vehicle_places__name",
          key: "vehicle_places__name",
          title: this.dataLang["fine_subs_managment_text6"],
          align: "center",
          width: "15%",
        },
        {
          field: "cities__name",
          key: "cities__name",
          title: this.dataLang["fine_subs_managment_text5"],
          align: "center",
          width: "15%",
        },
      ];
    },
    countObjectsWithFinesSubscription() {
      return (this.objects ?? []).filter(
        (item) => item.vehicles__is_active_fines
      ).length;
    },
    quickFilterMarkModelOptions() {
      return Object.entries(this.filter?.names ?? {})
        .map(([vehicles__name, label]) => ({
          vehicles__name,
          label: this.dataLang[label] ?? label,
        }))
        .sort((a, b) => {
          if (a.vehicles__name === "*") return -1;
          if (b.vehicles__name === "*") return 1;
          return 0;
        });
    },
    quickFilterTypeOptions() {
      return Object.entries(this.filter?.types ?? {})
        .map(([vehicle_types__code, name]) => ({
          vehicle_types__code,
          label: this.dataLang[name] ?? name,
        }))
        .sort((a, b) => {
          if (a.vehicle_types__code === "*") return -1;
          if (b.vehicle_types__code === "*") return 1;
          return 0;
        });
    },
    quickFilterCitiesOptions() {
      return Object.entries(this.filter?.cities ?? {})
        .map(([cities__id, cities__name]) => ({
          cities__id,
          label: this.dataLang[cities__name] ?? cities__name,
        }))
        .sort((a, b) => {
          if (a.cities__id === "*") return -1;
          if (b.cities__id === "*") return 1;
          return 0;
        });
    },
    quickFilterPlacesOptions() {
      return Object.entries(this.filter?.places ?? {})
        .map(([vehicle_places__id, vehicle_places__name]) => ({
          vehicle_places__id,
          label: this.dataLang[vehicle_places__name] ?? vehicle_places__name,
        }))
        .sort((a, b) => {
          if (a.vehicle_places__id === "*") return -1;
          if (b.vehicle_places__id === "*") return 1;
          return 0;
        });
    },
  },
  created() {
    GeneralService.get("/fines/table/tariff")
      .then((res) => {
        this.tariffs = res.data.data;
      })
      .catch(() => {
        this.$toast.error("Ошибка загрузки тарифов", { duration: 5000 });
      });
    GeneralService.get("/objects/table/finesmanagment")
      .then((res) => {
        this.objects = res.data.data.rows.map((item) => ({
          ...item,
          vehicles__is_active_fines: item.vehicles__is_active_fines === 1,
        }));
        this.selectedRowKeys = this.objects
          .filter((item) => item.vehicles__is_active_fines === true)
          .map((item) => item.vehicles__id);
        this.filter = res.data.data.filter;
      })
      .catch(() => {
        this.$toast.error("Ошибка загрузки данных", { duration: 5000 });
      });
  },
};
</script>
